import * as yup from "yup"

export const REQUIRED = "Required"
export const INVALID_EMAIL = "Invalid emaill address"

const email = yup
  .string()
  .email(INVALID_EMAIL)
  .required(REQUIRED)

const brokerName = yup.string().trim()
const brokerEmail = yup.string().email(INVALID_EMAIL)
const details = yup
  .string()
  .trim()
  .required(REQUIRED)

export const validationSchema = {
  email,
  brokerName,
  brokerEmail,
  details
}
